export default __webpack_public_path__ + "static/media/coal.ebbc99e3.png";